import { UserLanguageContext } from '@/contexts';
import { useContext } from 'react';

export const useUserLanguage = () => {
  const context = useContext(UserLanguageContext);

  if (!context) throw new Error("useUserLanguaje must be wrapped by useUserLanguageContextProvider");

  return context
}